<template>
  <div class="with-side-panel">
    <div class="content-i">
      <div class="content-box">
        <div class="element-wrapper">
          <div class="d-flex justify-content-between">
            <h6 class="element-header">
              Email info
            </h6>

            <CreateButton
                :label="$t('general.button.back')"
                :to="{ name: 'sendEmailList' }">
            </CreateButton>
          </div>

          <div class="element-box">
            <table class="table table-striped">
              <tbody>
              <tr>
                <th scope="row" style="width: 200px">Hergestellt in</th>
                <td>{{ email.createdAt }}</td>
              </tr>
              <tr>
                <th scope="row" style="width: 200px">Status</th>
                <td>
                   <span v-if="email.status === 'sent'">
                       <span class="status-pill green p-2 me-2"
                             data-bs-toggle="tooltip">
                       </span>
                   </span>
                  <span v-else>
                     <span class="status-pill red p-2 me-2"
                           data-bs-toggle="tooltip">
                       </span>
                  </span>
                  {{ email?.statusTranslated }}
                </td>
              </tr>
              <tr>
                <th scope="row" style="width: 200px">Typ</th>
                <td>{{ email?.typeTranslated }}</td>
              </tr>
              <tr>
                <th scope="row" style="width: 200px">Senden an</th>
                <td>{{ email?.receiverEmail }}</td>
              </tr>
              <tr>
                <th scope="row" style="width: 200px">Senden Sie an</th>
                <td>{{ email?.sendAt }}</td>
              </tr>
              <tr>
                <th style="width: 200px">Fehler</th>
                <td>
                  <div v-if="email.errors && email.errors.length">
                    <div v-for="(error) in email.errors" :key="error">
                      {{ error }}
                    </div>
                  </div>
                  <div v-else>
                    kein Fehler
                  </div>
                </td>
              </tr>
              </tbody>
            </table>

            <div class="mt-5">
              <div class="custom-css">
                <div v-html="email?.content"></div>
              </div>

              <div v-if="email.status === 'error'">
                <div class="mt-5 text-center">

                  <button class="btn btn-primary"
                          @click="router.push({name: 'officeForm', params: {id: office?.id} })">
                    Nochmal senden
                  </button>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import sendEmailService from '@/api/SendEmail';
import CreateButton from '@/components/CreateButton.vue';
import { ErrorToast } from '@/components/VueToast';
import router from '@/router';
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

const { t }   = useI18n();
const route   = useRoute();
const emailId = route.params.id;
const email   = ref({ content: '' });

async function getEmailDetails() {
  try {
    const { data } = await sendEmailService.getEmailDetails(+emailId);
    email.value = data.data;
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  await getEmailDetails();
});

</script>

<style>
.custom-css h4 {
  font-size: 24px !important;
  margin-top: 25px;
  margin-bottom: 15px;
}

.custom-css .email_header {
  height: 50px !important;
  margin-bottom: 30px;
}

.custom-css .email_footer p {
  margin-top: 5px;
}
</style>